import React, { useState, useEffect, useRef } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Table, BarChart } from "react-bootstrap-icons"
import "./table.css";
import Select from "react-select";
import { MdRefresh } from "react-icons/md";
import { TabView, TabPanel } from "primereact/tabview";
import { MdNotificationsActive } from "react-icons/md";
import { BlobServiceClient } from "@azure/storage-blob";
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"
import { Container, Row, Col } from 'react-bootstrap';
import { useAuth0 } from "@auth0/auth0-react";

const AUTH_KEYS = [
  "JWT", "userName", "organization", "loginType", "companyid", "companyName", "features",
  "legal1", "business1", "country1", "site1", "year1",
  "scope2legal", "scope2business", "scope2country", "scope2site", "scope2supplier", "scope2year",
  "businessTravelLegal", "businessTravelBusiness", "businessTravelCountry", "businessTravelSite", "businessTravelYear",
  "transportlegal", "transportbusiness", "transportcountry", "transportsite", "transportyear",
  "sbusiness", "scountry", "sjob", "slegal", "ssite", "syear",
  "allconfig", "report", "reportStatusData", "report_name",
  "savedReports", "savedStatus", "savedSurveys",
  "brsr_report_id", "brsr_sectionA_data", "brsrSectionCPopup",
  "step1", "step2", "step2Draft", "step3", "step4",
  "answers", "answers1", "answers2", "tableAnswers",
  "selectedOptions", "csrd", "type", "mdrp", "e1", "s1",
  "scfFormInProgress", "scfStep1", "scfStep2",
  "editFieldMapping", "popup1", "popup2", "popup3",
  "bloburl", "logo", "hash", "linkToken", "linkUrl",
  "weblink", "statusDashboardUrl", "statusReportFile",
  "oldp", "redirectAfterLogin",
];

const ESGBenchmarking = () => {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const [isOpen, setIsOpen] = useState(false);
  const username = localStorage.getItem("userName");
  const handleLogout = () => {
    AUTH_KEYS.forEach(k => localStorage.removeItem(k));
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    companyName: [],
    sector: [],
    country: [],
    competitors: [],
    year: [],
  });
  const [viewMode, setViewMode] = useState("table")
  const [data, setData] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [sectorOptions, setSectorOptions] = useState([]);
  const [competitorsOptions, setCompetitorsOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [tab3total, setTab3Total] = useState();
  const [tab2total, setTab2Total] = useState();
  const [searchText, setSearchText] = useState("");
  const [fontSize, setFontSize] = useState(window.innerWidth >= 1400 ? "15px" : "13px");

  const resetSelections = () => {
    setFormData({
      companyName: null, // ✅ Change from [] to null for clearing the dropdown
      sector: [],
      country: [],
      competitors: [],
      year: "",
    });
    setSearchText(""); 
    setFilteredEmissionsData([]);
    setFilteredTargetsData([]);
    setFilteredReportingData([]);
  };

  const [filteredEmissionsData, setFilteredEmissionsData] = useState([]);
  const [filteredTargetsData, setFilteredTargetsData] = useState([]);
  const [filteredReportingData, setFilteredReportingData] = useState([]);

  const fileInputRef = useRef(null);

  const handleUploadClick = () => {
    // Trigger the file input click
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    // Access the uploaded files
    const files = event.target.files;
    if (files.length > 0) {
      console.log("Files selected:", files);
      // Add logic to handle file upload
    }
  };

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company: { value: null, matchMode: FilterMatchMode.CONTAINS },
    sector: { value: null, matchMode: FilterMatchMode.CONTAINS },
    country: { value: null, matchMode: FilterMatchMode.CONTAINS },
    year: { value: null, matchMode: FilterMatchMode.CONTAINS },
    revenue: { value: null, matchMode: FilterMatchMode.CONTAINS },
    employees: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope1: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope2: { value: null, matchMode: FilterMatchMode.CONTAINS },
    scope3: { value: null, matchMode: FilterMatchMode.CONTAINS },
    totalEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    economicEmissionIntensity: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [emissionsData, setEmissionsData] = useState([]);
  const [targetsData, setTargetsData] = useState([]);
  const [reportingData, setReportingData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [companyFilter, setCompanyFilter] = useState("");
  const [sectorFilter, setSectorFilter] = useState("");
  const [countryFilter, setCountryFilter] = useState("");
  const [yearFilter, setYearFilter] = useState("");
  const [competitorFilter, setCompetitorFilter] = useState([]);

  const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  // Determine if filters are applied
  const isFilterApplied = Object.values(formData).some((value) => value);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: value, matchMode: FilterMatchMode.CONTAINS },
    }));
    setGlobalFilterValue(value);
  };


  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <span className="p-input-icon-left">
          <img src="assets/img/search.png" className="search-i" alt="search" />
          <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
        </span>
      </div>
    );
  };

  const header = renderHeader();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: "#00366D26",
      background: "#F5F5F5",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#407775", // Change border color on hover
      },
      fontSize: fontSize, // Set font size for control (including selected option)
      color: "#707070!important", // Set default text color for the control
      paddingLeft:
        state.selectProps.name === "companyName" && (!formData.companyName || formData.companyName.length === 0)
          ? "30px"
          : state.selectProps.name === "sector" && (!formData.sector || formData.sector.length === 0)
          ? "30px"
          : state.selectProps.name === "region" && (!formData.region || formData.region.length === 0)
          ? "30px"
          : state.selectProps.name === "country" && (!formData.country || formData.country.length === 0)
          ? "30px"
          : state.selectProps.name === "competitors" && (!formData.competitors || formData.competitors.length === 0)
          ? "30px"
          : state.selectProps.name === "year" && (!formData.year || formData.year.length === 0)
          ? "30px"
          : "0px", // Default padding if the field is filled
      position: "relative",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#707070",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        color: "#707070", // Change border color on hover
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Hide the separator
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the menu is above other elements
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused || state.isSelected ? "#eef1f5" : "white", // Hover and selected background color
      color: state.isSelected ? "#407775" : "#707070", // Change text color for selected options
      fontSize: fontSize, // Use fontSize state variable for options
      "&:active": {
        backgroundColor: "#eef1f5", // Change color on active (click)
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: fontSize, // Set font size for the placeholder
      color: "#707070", // Set placeholder color
    }),
  };

  // Sample data for charts

  const cardData = [
    {
      id: 1,
      title: 'Emissions Benchmarking',
      description: 'Analyze and compare carbon footprints to industry standards for better.',
      defaultIcon: 'assets/img/esg-icon/E1-1.svg',
      hoverIcon: 'assets/img/esg-icon/E1.svg',
      link: '/Emission-benchmarking'
    },
    {
      id: 2,
      title: 'Emissions Targets',
      description: 'Set, track, and achieve carbon reduction goals to drive sustainable progress.',
      defaultIcon: 'assets/img/esg-icon/E2-2.svg',
      hoverIcon: 'assets/img/esg-icon/E2.svg',
      link: '/Emission-targets'
    },
    {
      id: 3,
      title: 'ESG Reporting Standards/Frameworks',
      description: 'Ensure compliance with global ESG frameworks for transparent and credible sustainability reporting.',
      defaultIcon: 'assets/img/esg-icon/E3.svg',
      hoverIcon: 'assets/img/esg-icon/E3-3.svg',
      link: '/ESG-reporting-SF'
    },
    {
      id: 4,
      title: 'CSRD Benchmarking',
      description: 'Align sustainability disclosures with CSRD requirements to meet EU regulatory standards.',
      defaultIcon: 'assets/img/esg-icon/E4.svg',
      hoverIcon: 'assets/img/esg-icon/E4-4.svg',
      link: '/csrd-benchmarking'
    }
  ];

  const handleCardClick = (id) => {
    if (selected === id) {
      setSelected(null) // Deselect if already selected
    } else {
      setSelected(id) // Select the card
    }
  }
 
  const [selected, setSelected] = useState(null);
  const [hovered, setHovered] = useState(null);
  return (
    <div id="wrapper">
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <div id="">
        <header>
          <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
            <div className="container-fluid  mx-4 my-2">
              <div className="d-flex align-items-center">
                <a className="navbar-brand d-flex align-items-center p-0" href="#home">
                  <img src="assets/img/logo.png" alt="Company Logo" height="30" />
                </a>
                <div
                  className="mx-2"
                  style={{
                    borderLeft: "1px solid #fff",
                    height: "30px",
                    paddingLeft: "20px",
                    opacity: "0.5",
                  }}
                ></div>
                <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                  Organization Name
                </span>
              </div>
              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0 d-flex align-items-center">
                  <li className="nav-item">
                    <a className="nav-link  text-white" href="#notifications">
                      <MdNotificationsActive className="icon" style={{ width: "1.5rem", height: "1.5rem" }} />
                    </a>
                  </li>
                  <li className="nav-item">
                    <span className="text-white nav-link" style={{ opacity: "0.7", fontSize: "14px", cursor: "default" }}>
                      {username}
                    </span>
                  </li>
                  <li className="nav-item dropdown" style={{ position: "relative" }}>
                    <a className="nav-link text-white" href="#" onClick={(e) => { e.preventDefault(); setIsOpen(!isOpen); }}>
                      <img className="icon mr-2" src="assets/img/User.png" alt="User" />
                    </a>
                    {isOpen && (
                      <ul className="dropdown-menu show" style={{ position: "absolute", right: 0, top: "100%", zIndex: 9999, minWidth: "160px", overflow: "hidden", borderRadius: "4px" }}>
                        <li><button onMouseEnter={e => { e.currentTarget.style.background = "#407775"; e.currentTarget.style.color = "#fff"; }} onMouseLeave={e => { e.currentTarget.style.background = "none"; e.currentTarget.style.color = "#212529"; }} style={{ color: "#212529", background: "none", border: "none", width: "100%", textAlign: "left", padding: "6px 16px", cursor: "pointer" }} onClick={handleLogout}>Logout</button></li>
                      </ul>
                    )}
                  </li>
                  <li className="nav-item">
                    <span className="text-white" style={{ opacity: "0.7", fontSize: "14px" }}>
                      XYZ ltd
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </header>

        <div className="container survey-form scf p-4 p-lg-5">
          <div className="row">
            <div className="col">
              
              <Link to="/esg-benchmarking" style={{ color: "#407775", fontSize: "14px", textDecoration: "none" }}>
                  Home
              </Link>
            </div>
          </div>
          <div className="row my-4">
            <div className="col">
              <div className="form-header d-flex justify-content-between">
                
                <h1 className="title" style={{ color: "#494949" }}>
                  Benchmarking
                </h1>
              
              </div>
            </div>
          </div>
        
    
          <Row className="card-container g-4">
        {cardData.map((card) => (
          <Col xs={12} sm={6} lg={3} key={card.id} className="d-flex">
          <Link to={card.link} className="d-flex flex-fill" style={{ textDecoration: 'none' }}>
            <div
              onClick={() => handleCardClick(card.id)}
              onMouseEnter={() => setHovered(card.id)}
              onMouseLeave={() => setHovered(null)}
              className={`card-box flex-fill ${selected === card.id ? "selected" : ""}`}
            >
            <div className="icon-wrapper">
  <img
    src={hovered === card.id ? card.hoverIcon : card.defaultIcon}
    alt="card icon"
    className="card-icon"
  />
</div>
              <h2 className="card-title">{card.title}</h2>
              <p className="card-description">{card.description}</p>
            </div>
            </Link>
          </Col>
        ))}
      </Row>
  


        </div>
      </div>
    </div>
  );
};

export default ESGBenchmarking;
